import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';


const accountContractsRoutes = [
  {
    path: 'contracts',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Contracts')
      },
      permissions: ['READ_CONTRACTS', 'READ_PAYERS']
    },
    children: [
      {
        path: '',
        name: 'contractsList',
        component: wrapLegacyRoute('contractsController', 'list')
      },
      {
        path: 'create',
        name: 'contractCreate',
        component: wrapLegacyRoute('contractsController', 'create')
      },
      {
        path: ':contractId(\\d+)',
        name: 'contractDetails',
        component: wrapLegacyRoute('contractsController', 'details')
      },
      {
        path: ':contractId(\\d+)/history',
        name: 'contractStatusHistory',
        component: wrapLegacyRoute('contractsController', 'contractStatusHistory')
      }
    ]
  }
];

export default accountContractsRoutes;
